export default [
  {
    title: 'bookingFollowups.title', icon: 'PhoneCallIcon', route: 'booking-followups', resource: 'bookingFollowup', action: 'read',
  },
  {
    title: 'doctorPolicy.title', icon: 'UsersIcon', route: 'article-doctor-policy', resource: 'article', action: 'read',
  },
  {
    title: 'operationalReports.title', icon: 'BarChartIcon', route: 'operational-reports', resource: 'operationalReporting', action: 'read',
  },
  {
    title: 'contentCampaigns.title', icon: 'TargetIcon', route: 'content-campaign-list', resource: 'contentCampaign', action: 'read',
  },
  {
    header: 'articles.mainVerticalMenu.content',
  },
  {
    title: 'momExperiences.mainVerticalMenu.momExperiences',
    icon: 'MoreVerticalIcon',
    resource: 'week',
    action: 'read',
    children: [
      {
        title: 'momExperiences.mainVerticalMenu.momExperiencesList',
        route: 'pages-momExperiences-list',
        resource: 'momExperience',
        action: 'read',
      },
      {
        title: 'momExperiences.mainVerticalMenu.momExperienceAdd',
        route: 'pages-momExperiences-add',
        resource: 'momExperience',
        action: 'create',
      },
    ],
  },
  {
    title: 'weeks.mainVerticalMenu.weeks',
    icon: 'MoreVerticalIcon',
    resource: 'week',
    action: 'read',
    children: [
      {
        title: 'weeks.mainVerticalMenu.weeksList',
        route: 'pages-weeks-list',
        resource: 'week',
        action: 'read',
      },
      {
        title: 'weeks.mainVerticalMenu.weekAdd',
        route: 'pages-weeks-add',
        resource: 'week',
        action: 'create',
      },
    ],
  },
  {
    title: 'tags.mainVerticalMenu.tags',
    icon: 'TagIcon',
    resource: 'tag',
    action: 'read',
    children: [
      {
        title: 'tags.mainVerticalMenu.tagsList',
        route: 'pages-tags-list',
        resource: 'tag',
        action: 'read',
      },
      {
        title: 'tags.mainVerticalMenu.tagAdd',
        route: 'pages-tags-add',
        resource: 'tag',
        action: 'create',
      },
    ],
  },

  {
    title: 'articleCategories.mainVerticalMenu.articleCategories',
    icon: 'ListIcon',
    resource: 'article',
    action: 'read',
    children: [
      {
        title: 'articleCategories.mainVerticalMenu.articleCategoriesList',
        route: 'pages-article-categories-list',
        resource: 'articleCategory',
        action: 'read',
      },
      {
        title: 'articleCategories.mainVerticalMenu.articleCategoryAdd',
        route: 'pages-article-categories-add',
        resource: 'articleCategory',
        action: 'create',
      },
    ],
  },
  {
    title: 'articles.mainVerticalMenu.articles',
    icon: 'FileTextIcon',
    resource: 'article',
    action: 'read',
    children: [
      {
        title: 'articles.mainVerticalMenu.articlesList',
        route: 'pages-articles-list',
        resource: 'article',
        action: 'read',
      },
      {
        title: 'articles.mainVerticalMenu.articleAdd',
        route: 'pages-articles-add',
        resource: 'article',
        action: 'create',
      },
    ],
  },
  {
    title: 'questions.mainVerticalMenu.questions',
    icon: 'HelpCircleIcon',
    resource: 'question',
    action: 'read',
    children: [
      {
        title: 'questions.mainVerticalMenu.questionsList',
        route: 'pages-questions-list',
        resource: 'question',
        action: 'read',
      },
      {
        title: 'questions.mainVerticalMenu.questionAdd',
        route: 'pages-questions-add',
        resource: 'question',
        action: 'create',
      },
    ],
  },
  {
    title: 'videos.mainVerticalMenu.videos',
    icon: 'VideoIcon',
    resource: 'article',
    action: 'read',
    children: [
      {
        title: 'videos.mainVerticalMenu.videosList',
        route: 'pages-videos-list',
        resource: 'article',
        action: 'read',
      },
      {
        title: 'videos.mainVerticalMenu.videoAdd',
        route: 'pages-videos-add',
        resource: 'article',
        action: 'create',
      },
    ],
  },
  // {
  //   title: "pages.mainVerticalMenu.pages",
  //   icon: "LayoutIcon",
  //   children: [
  //     {
  //       title: "pageCategories.mainVerticalMenu.pageCategories",
  //       icon: "LayersIcon",
  //       resource: "pageCategory",
  //       action: "read",
  //       children: [
  //         {
  //           title: "pageCategories.mainVerticalMenu.pageCategoriesList",
  //           route: "pages-page-categories-list",
  //           resource: "pageCategory",
  //           action: "read",
  //         },
  //         {
  //           title: "pageCategories.mainVerticalMenu.pageCategoryAdd",
  //           route: "pages-page-categories-add",
  //           resource: "pageCategory",
  //           action: "create",
  //         },
  //       ],
  //     },
  //     {
  //       title: "pages.mainVerticalMenu.pages",
  //       icon: "LayoutIcon",
  //       resource: "page",
  //       action: "read",
  //       children: [
  //         {
  //           title: "pages.mainVerticalMenu.pagesList",
  //           route: "pages-pages-list",
  //           resource: "page",
  //           action: "read",
  //         },
  //         {
  //           title: "pages.mainVerticalMenu.pageAdd",
  //           route: "pages-pages-add",
  //           resource: "page",
  //           action: "create",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "pageCategories.mainVerticalMenu.pageCategories",
  //   icon: "LayersIcon",
  //   resource: "pageCategory",
  //   action: "read",
  //   children: [
  //     {
  //       title: "pageCategories.mainVerticalMenu.pageCategoriesList",
  //       route: "pages-page-categories-list",
  //       resource: "pageCategory",
  //       action: "read",
  //     },
  //     {
  //       title: "pageCategories.mainVerticalMenu.pageCategoryAdd",
  //       route: "pages-page-categories-add",
  //       resource: "pageCategory",
  //       action: "create",
  //     },
  //   ],
  // },
  // {
  //   title: "pages.mainVerticalMenu.pages",
  //   icon: "LayoutIcon",
  //   resource: "page",
  //   action: "read",
  //   children: [
  //     {
  //       title: "pages.mainVerticalMenu.pagesList",
  //       route: "pages-pages-list",
  //       resource: "page",
  //       action: "read",
  //     },
  //     {
  //       title: "pages.mainVerticalMenu.pageAdd",
  //       route: "pages-pages-add",
  //       resource: "page",
  //       action: "create",
  //     },
  //   ],
  // },
  // {
  //   title: "FAQs.mainVerticalMenu.FAQs",
  //   icon: "HelpCircleIcon",
  //   children: [
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQCategory",
  //       icon: "ListIcon",
  //       resource: "faqCategory",
  //       action: "read",
  //       children: [
  //         {
  //           title: "FAQs.mainVerticalMenu.FAQCategoryList",
  //           route: "pages-FAQs-categories-list",
  //           resource: "faqCategory",
  //           action: "read",
  //         },
  //         {
  //           title: "FAQs.mainVerticalMenu.FAQCategoryAdd",
  //           route: "pages-FAQs-categories-add",
  //           resource: "faqCategory",
  //           action: "create",
  //         },
  //       ],
  //     },
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQs",
  //       icon: "HelpCircleIcon",
  //       resource: "faq",
  //       action: "read",
  //       children: [
  //         {
  //           title: "FAQs.mainVerticalMenu.FAQsList",
  //           route: "pages-FAQs-list",
  //           resource: "faq",
  //           action: "read",
  //         },
  //         {
  //           title: "FAQs.mainVerticalMenu.FAQAdd",
  //           route: "pages-FAQs-add",
  //           resource: "faq",
  //           action: "create",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "FAQs.mainVerticalMenu.FAQCategory",
  //   icon: "ListIcon",
  //   resource: "faqCategory",
  //   action: "read",
  //   children: [
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQCategoryList",
  //       route: "pages-FAQs-categories-list",
  //       resource: "faqCategory",
  //       action: "read",
  //     },
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQCategoryAdd",
  //       route: "pages-FAQs-categories-add",
  //       resource: "faqCategory",
  //       action: "create",
  //     },
  //   ],
  // },
  // {
  //   title: "FAQs.mainVerticalMenu.FAQs",
  //   icon: "HelpCircleIcon",
  //   resource: "faq",
  //   action: "read",
  //   children: [
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQsList",
  //       route: "pages-FAQs-list",
  //       resource: "faq",
  //       action: "read",
  //     },
  //     {
  //       title: "FAQs.mainVerticalMenu.FAQAdd",
  //       route: "pages-FAQs-add",
  //       resource: "faq",
  //       action: "create",
  //     },
  //   ],
  // },

  {
    title: 'testimonials.mainVerticalMenu.testimonials',
    icon: 'StarIcon',
    resource: 'testimonial',
    action: 'read',
    children: [
      {
        title: 'testimonials.mainVerticalMenu.testimonialsList',
        route: 'pages-testimonials-list',
        resource: 'testimonial',
        action: 'read',
      },
      {
        title: 'testimonials.mainVerticalMenu.testimonialAdd',
        route: 'pages-testimonials-add',
        resource: 'testimonial',
        action: 'create',
      },
    ],
  },
  {
    title: 'suggestions.mainVerticalMenu.suggestions',
    icon: 'MessageCircleIcon',
    resource: 'suggestions',
    action: 'read',
    children: [
      {
        title: 'suggestions.mainVerticalMenu.suggestionsList',
        route: 'pages-suggestions-list',
        resource: 'suggestions',
        action: 'read',
      },
      {
        title: 'suggestions.suggestionsArchive',
        route: 'pages-suggestions-archive',
        resource: 'suggestions',
        action: 'read',
      },
    ],
  },
  {
    title: 'feedback.feedback',
    icon: 'MessageCircleIcon',
    resource: 'feedback',
    action: 'read',
    children: [
      {
        title: 'feedback.feedbackList',
        route: 'pages-feedback-list',
        resource: 'feedback',
        action: 'read',
      },
      {
        title: 'feedback.feedbackArchive',
        route: 'pages-feedback-archive',
        resource: 'feedback',
        action: 'read',
      },
    ],
  },
  {
    title: 'comments.mainVerticalMenu.comments',
    icon: 'MessageSquareIcon',
    route: 'pages-comment-list',
    resource: 'comments',
    action: 'read',
  },
  {
    title: 'unit.units',
    icon: 'HomeIcon',
    resource: 'unit',
    action: 'read',
    children: [
      {
        title: 'unit.unitList',
        route: 'pages-units-list',
        resource: 'unit',
        action: 'read',
      },
      {
        title: 'unit.createUnit',
        route: 'pages-units-add',
        resource: 'unit',
        action: 'create',
      },

    ],
  },
]
